import {Expose} from "class-transformer";

export default class ModelAccountProject {
    @Expose({name: 'name'})
    private readonly _name: string;
    @Expose({name: 'slug'})
    private readonly _slug: string;
    @Expose({name: 'link'})
    private readonly _link: string | null = null;

    constructor(name: string, slug: string, link: string | null) {
        this._name = name;
        this._slug = slug;
        this._link = link;
    }

    public get name(): string {
        return this._name;
    }

    public get slug(): string {
        return this._slug;
    }

    public get link(): string | null {
        return this._link;
    }
}
